export default "__VITE_ASSET__Ba5lWy$e__"